import { useMutation } from 'react-query';
import { REST_MNGT_ENDPOINT } from 'src/config';

const useMutationRunRestaurantOpenProcedure = () => {
  return useMutation(
    `run_restaurant_open_procedure`,
    async (rest_id) => {
      const response = await fetch(
        `${REST_MNGT_ENDPOINT}/runRestaurantOpenProcedure?rest_id=${rest_id}`
      );

      if (!response.ok) {
        // alert('runRestaurantOpenProcedure error');
        console.error(
          'error during calling runRestaurantOpenProcedure ',
          response
        );
      }

      return response.json();
    },
    { retry: 5 }
  );
};

export default useMutationRunRestaurantOpenProcedure;
